import React from 'react';
import type { FC } from 'react';
import { Trans, useTranslation } from '@wix/cli-i18n';
import type { VariantOf } from 'variant';
import { Link, SelectInput } from '@wix/cli-ui-kit';
import { variant } from 'variant';
import { useCreateAppBi } from '../../bi/index.js';

export const IdeForMcp = variant({
  VsCode: {},
  Cursor: {},
  ClaudeCode: {},
});

export type IdeForMcp = VariantOf<typeof IdeForMcp>;

interface ConfigMcpProps {
  onSelected: (ideName?: IdeForMcp) => void;
}

export const ConfigMcp: FC<ConfigMcpProps> = ({ onSelected }) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();

  return (
    <SelectInput<IdeForMcp | undefined>
      label={t('create_app.choose_ide_for_mcp.question')}
      info={
        <Trans
          i18nKey="create_app.choose_ide_for_mcp.description"
          components={[
            <Link url="https://www.wix.com/studio/developers/mcp-server" />,
          ]}
        />
      }
      options={[
        {
          title: t('create_app.choose_ide_for_mcp.answer.cursor'),
          key: 'cursor',
          value: IdeForMcp.Cursor(),
        },
        {
          title: t('create_app.choose_ide_for_mcp.answer.vscode'),
          key: 'vscode',
          value: IdeForMcp.VsCode(),
        },
        {
          title: t('create_app.choose_ide_for_mcp.answer.claude_code'),
          key: 'claude_code',
          value: IdeForMcp.ClaudeCode(),
        },
        {
          title: t('create_app.choose_ide_for_mcp.answer.no'),
          key: 'no',
          value: undefined,
        },
      ]}
      onSubmit={({ value }) => {
        cliFlowStepAnswered({
          question: t('create_app.choose_ide_for_mcp.question'),
          questionKey: 'create_app.choose_ide_for_mcp.question',
          answer: value?.type ?? 'No',
        });
        onSelected(value);
      }}
    />
  );
};
